module.exports = __webpack_public_path__ + "img/sec1_3.c20f0f2a.png";